import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12dbb152"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "operate-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "from-content"
};
const _hoisted_4 = {
  class: "item-warpper"
};
const _hoisted_5 = {
  class: "img-content flex"
};
const _hoisted_6 = {
  class: "upload-c"
};
const _hoisted_7 = {
  class: "img-list"
};
const _hoisted_8 = ["onMouseenter"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 0,
  class: "is-thumb"
};
const _hoisted_12 = {
  class: "thumb-tip"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#999",
    "font-size": "12px"
  }
}, " 图片仅支持jpg/jpeg/png格式， 文件大小不能超过2M ", -1));
const _hoisted_14 = {
  class: "item-warpper"
};
const _hoisted_15 = {
  class: "img-content flex"
};
const _hoisted_16 = {
  class: "upload-c"
};
const _hoisted_17 = {
  class: "img-list"
};
const _hoisted_18 = ["onMouseenter"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 0,
  class: "is-thumb"
};
const _hoisted_22 = {
  class: "thumb-tip"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#999",
    "font-size": "12px"
  }
}, " 视频仅支持mp4格式， 文件大小不能超过30M ", -1));
import { getCaseCategoryListApi, getDoctorDepListApi, getDoctorListApi } from "@/service/modules/case";
import { reactive, ref, onMounted, markRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import separateUpload from "@/components/separate-upload.vue";
import { addCaseApi } from "@/service/modules/case";
import { localCache } from "@/utils/cache";
import { QuestionFilled } from "@element-plus/icons-vue";
import WangEditor from "@/components/wang-editor.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'operate',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const title = ref("添加案例");
    const hoverIndex = ref(-1);
    const hoverVideoIndex = ref(-1);
    const formRef = ref();
    const subLoading = ref(false);
    const caseId = ref(null);
    const caseInfo = ref(null);
    const form = reactive({
      dept_id: null,
      cate_id: null,
      doctor_id: "",
      thumb: "",
      img_list: [],
      video_list: [],
      status: 1,
      desc: ""
    });
    let copyForm = {};
    const doctorDepList = ref([]);
    const doctorList = ref([]);
    const categoryList = ref([]);
    const doctorPage = reactive({
      page: 1,
      pageSize: 500
    });
    const cateMap = ref({});
    const rules = {
      dept_id: [{
        required: true,
        message: "请选择科室",
        trigger: "change"
      }],
      cate_id: [{
        required: true,
        message: "请选择分类",
        trigger: "change"
      }],
      doctor_id: [{
        required: true,
        message: "请选择医生",
        trigger: "change"
      }],
      thumb: [{
        required: true,
        message: "请设置封面",
        trigger: "change"
      }]
      // video_list: [{ required: true, message: '请上传视频', trigger: 'change' },],
    };
    getDoctorDepList();
    // 科室列表
    async function getDoctorDepList() {
      try {
        let res = await getDoctorDepListApi();
        doctorDepList.value = res.data;
      } catch {}
    }
    // 分类
    async function getCaseCategoryList(id) {
      try {
        let res = await getCaseCategoryListApi(id);
        cateMap.value[id] = res.data;
      } catch {}
    }
    async function deptSelectChange(val) {
      if (cateMap.value[val]) {
        categoryList.value = cateMap.value[val];
      } else {
        await getCaseCategoryList(val);
        categoryList.value = cateMap.value[val];
      }
      await getDoctorList();
      form.cate_id = null;
      form.doctor_id = null;
    }
    // 医生
    async function getDoctorList() {
      let params = {
        ...doctorPage,
        dept_id: form.dept_id,
        status: 1
      };
      try {
        let res = await getDoctorListApi(params);
        doctorList.value = res.data.data;
      } catch {}
    }
    function imgTypeError() {
      ElMessage.warning("仅支持jpg/jpeg/png格式图片");
    }
    function imgLoadSuccess(img) {
      form.img_list.push(img);
    }
    function videoTypeError() {
      ElMessage.warning("仅支持mp4格式视频");
    }
    function videoLoadSuccess(video) {
      form.video_list.push(video);
    }
    // 设为封面
    function handleSettingThumb(img, index) {
      form.thumb = img;
      hoverIndex.value = -1;
      hoverVideoIndex.value = -1;
    }
    function handleRemoveImg(index) {
      form.img_list.splice(index, 1);
    }
    function handleRemoveVideo(index) {
      form.video_list.splice(index, 1);
    }
    function handleImgListEnter(index, img) {
      if (!form.thumb.includes(img)) {
        hoverIndex.value = index;
      }
    }
    function handleImgListLeave() {
      hoverIndex.value = -1;
    }
    function handleVideoListEnter(index, video) {
      if (!form.thumb.includes(video)) {
        hoverVideoIndex.value = index;
      }
    }
    function handleVideoListLeave() {
      hoverVideoIndex.value = -1;
    }
    function handleBtn(type) {
      if (type) {
        formRef.value?.validate(valid => {
          if (valid) {
            submit();
          }
        });
      } else {
        let res = checkValid();
        console.log("res", res);
        if (!res) {
          ElMessageBox.confirm("数据发生更改, 是否需要离开？", "温馨提示", {
            confirmButtonText: "留在本页",
            cancelButtonText: "离开本页",
            type: "warning",
            icon: markRaw(QuestionFilled)
          }).then(() => {}).catch(() => {
            router.back();
          });
        } else {
          router.back();
        }
      }
    }
    async function submit() {
      subLoading.value = true;
      let params = {
        dept_id: form.dept_id,
        cate_id: form.cate_id,
        doctor_id: form.doctor_id,
        thumb: form.thumb,
        img_list: JSON.stringify(form.img_list),
        video_list: JSON.stringify(form.video_list),
        desc: form.desc === "<p><br></p>" ? "" : form.desc
      };
      if (caseId.value) {
        params.id = caseInfo.value.id;
      }
      console.log("params", params);
      try {
        await addCaseApi(params);
        ElMessage.success(caseId.value ? "案例编辑成功" : "案例创建成功");
        setTimeout(() => {
          router.push({
            path: "/case-store/case"
          });
        }, 700);
      } catch {} finally {
        setTimeout(() => {
          subLoading.value = false;
        }, 700);
      }
    }
    function checkValid() {
      for (let key in form) {
        if (key === "img_list" || key === "video_list") {
          if (form[key].length !== copyForm[key].length) {
            return false;
          } else if (form[key].length === copyForm[key].length && form[key].length > 0) {
            for (let i = 0; i < form[key].length; i++) {
              if (form[key][i] !== copyForm[key][i]) {
                return false;
              }
            }
          }
        } else {
          if (form[key] !== copyForm[key]) {
            return false;
          }
        }
      }
      return true;
    }
    onMounted(async () => {
      const query = route.query;
      if (query.case_id) {
        title.value = "编辑案例";
        caseId.value = query.case_id;
        let caseInfoLocal = localCache.getCache("caseInfo");
        caseInfo.value = caseInfoLocal;
        form.dept_id = caseInfoLocal.dept_id * 1;
        form.thumb = caseInfoLocal.thumb;
        form.img_list = JSON.parse(caseInfoLocal.img_list);
        form.video_list = JSON.parse(caseInfoLocal.video_list);
        form.desc = caseInfoLocal.desc;
        await deptSelectChange(form.dept_id);
        form.cate_id = caseInfoLocal.cate_id * 1;
        form.doctor_id = caseInfoLocal.doctor_id * 1;
      }
      copyForm = JSON.parse(JSON.stringify(form));
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_CloseBold = _resolveComponent("CloseBold");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        model: form,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "80px",
        rules: rules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "选择科室",
          prop: "dept_id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.dept_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.dept_id = $event),
            placeholder: "请选择科室",
            class: "w500p",
            onChange: deptSelectChange
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctorDepList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 256))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "选择分类",
          prop: "cate_id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: !form.dept_id,
            modelValue: form.cate_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.cate_id = $event),
            placeholder: "请选择分类",
            class: "w500p"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 256))]),
            _: 1
          }, 8, ["disabled", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "选择医生",
          prop: "doctor_id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: !form.dept_id,
            modelValue: form.doctor_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.doctor_id = $event),
            placeholder: "请选医生",
            class: "w500p"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctorList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 256))]),
            _: 1
          }, 8, ["disabled", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "图片",
          prop: "thumb"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(separateUpload, {
            maxSize: 2,
            accept: ".jpg, .png, .jpeg",
            "file-types": ['image/png', 'image/jpeg'],
            onTypeError: imgTypeError,
            onUploadSuccess: imgLoadSuccess
          })]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.img_list, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "img-item",
              onMouseenter: $event => handleImgListEnter(index, item),
              onMouseleave: handleImgListLeave
            }, [_createElementVNode("img", {
              src: item,
              alt: "",
              srcset: ""
            }, null, 8, _hoisted_9), _createElementVNode("div", {
              class: _normalizeClass(["setting flex-center", {
                'hover-active': index === hoverIndex.value
              }])
            }, [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => handleSettingThumb(item, 1)
            }, {
              default: _withCtx(() => [_createTextVNode("设为封面")]),
              _: 2
            }, 1032, ["onClick"])], 2), _createElementVNode("div", {
              class: _normalizeClass(["close", {
                'hover-active': index === hoverIndex.value
              }]),
              onClick: $event => handleRemoveImg(index)
            }, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_CloseBold)]),
              _: 1
            })], 10, _hoisted_10), form.thumb.includes(item) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_tag, {
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode("已设置为封面")]),
              _: 1
            })])])) : _createCommentVNode("", true)], 40, _hoisted_8);
          }), 256))])]), _hoisted_13])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "视频",
          prop: "thumb"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(separateUpload, {
            maxSize: 30,
            "file-types": ['video/mp4'],
            accept: ".mp4",
            onTypeError: videoTypeError,
            onUploadSuccess: videoLoadSuccess
          })]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.video_list, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "img-item video-item",
              onMouseenter: $event => handleVideoListEnter(index, item),
              onMouseleave: handleVideoListLeave
            }, [_createElementVNode("video", {
              src: item,
              controls: "",
              width: "100"
            }, null, 8, _hoisted_19), _createElementVNode("div", {
              class: _normalizeClass(["setting flex-center", {
                'hover-active': index === hoverVideoIndex.value
              }])
            }, [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => handleSettingThumb(item, 3)
            }, {
              default: _withCtx(() => [_createTextVNode("设为封面")]),
              _: 2
            }, 1032, ["onClick"])], 2), _createElementVNode("div", {
              class: _normalizeClass(["close", {
                'hover-active': index === hoverVideoIndex.value
              }]),
              onClick: $event => handleRemoveVideo(index)
            }, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_CloseBold)]),
              _: 1
            })], 10, _hoisted_20), form.thumb.includes(item) ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_tag, {
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode("已设置为封面")]),
              _: 1
            })])])) : _createCommentVNode("", true)], 40, _hoisted_18);
          }), 256))])]), _hoisted_23])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "详情介绍"
        }, {
          default: _withCtx(() => [_createVNode(WangEditor, {
            ref: "WangEditorRef",
            modelValue: form.desc,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.desc = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = $event => handleBtn(false))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            loading: subLoading.value,
            type: "primary",
            onClick: _cache[5] || (_cache[5] = $event => handleBtn(true))
          }, {
            default: _withCtx(() => [_createTextVNode("确定")]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]);
    };
  }
});